export const APP_LANGUAGE_KEY = 'fongpt-language';
export const APP_LANGUAGE_CHANGED_EVENT = 'fongpt-language-changed';

export type AppLanguage = 'en-US' | 'sr-RS';

export function normalizeAppLanguage(value?: string | null): AppLanguage {
  return value?.toLowerCase().startsWith('en') ? 'en-US' : 'sr-RS';
}

/** Locale used for browser-provided date and time labels. */
export function getIntlLocale(value?: string | null): string {
  return normalizeAppLanguage(value) === 'en-US' ? 'en-US' : 'sr-Latn-RS';
}

export function getHtmlLanguage(value?: string | null): 'en' | 'sr-Latn' {
  return normalizeAppLanguage(value) === 'en-US' ? 'en' : 'sr-Latn';
}

export function getStoredAppLanguage(
  fallback: AppLanguage = 'sr-RS'
): AppLanguage {
  try {
    const saved = localStorage.getItem(APP_LANGUAGE_KEY);
    return saved ? normalizeAppLanguage(saved) : fallback;
  } catch {
    return fallback;
  }
}

export function storeAppLanguage(language: AppLanguage): void {
  try {
    localStorage.setItem(APP_LANGUAGE_KEY, language);
    window.dispatchEvent(
      new CustomEvent(APP_LANGUAGE_CHANGED_EVENT, { detail: language })
    );
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }
}
